import { supabase } from '../supabaseClient'

class UserService {
  createUser = async (payload: any): Promise<any> => {
    let { error: insertError, data } = await supabase.from('Profile').insert(payload)
    if (insertError) {
      console.error(insertError)
    }
    return true
  }

  deleteUser = async (id: string): Promise<any> => {
    const { error } = await supabase.from('Profile').delete().eq('id', id)
    if (error) {
      console.error(error)
    }
    return true
  }

  countUsers = async (): Promise<any> => {
    const { data, error } = await supabase.from('profiles').select('id')
    if (error) {
      console.error('Error fetching total rows:', error)
    } else {
      return data?.length
    }
  }

  getPaginatedUsers = async (
    page: number,
    term?: string,
    sortOptions?: { sortField: string; sortDirection: 'asc' | 'desc' },
  ): Promise<any> => {
    let query = supabase
      .from('profiles')
      .select('*', { count: 'exact' })
      .range((page - 1) * 5, page * 5)
    if (term) {
      query = query.ilike('first_name', `%${term}%`)
    }
    if (sortOptions?.sortField && sortOptions.sortDirection) {
      query = query.order(sortOptions.sortField, {
        ascending: sortOptions.sortDirection === 'asc',
      })
    }
    const { data, count, error } = await query
    if (error) {
      console.error('Error in getPaginatedUsers:', error)
      return { data: [], count: 0 }
    }
    return {
      data: data || [],
      count: count || 0,
    }
  }

  getUserByUUID = async (user_uuid: string): Promise<any> => {
    const { data, error } = await supabase
      .from('simple_profile')
      .select('*')
      .eq('uuid', user_uuid)
      .single()

    console.log('users data', data)
    if (error) {
      if (error.message.includes('No rows')) {
        console.warn(`User with UUID ${user_uuid} does not exist.`)
      } else {
        console.error('Error fetching user by UUID:', error)
      }
      return null
    }
    return data
  }
}

const userService = new UserService()

export default userService
